import React from 'react';

const JsonToModelControls = ({ config, onChange }) => {
  const handleChange = (key, value) => {
    onChange({ [key]: value });
  };

  const validateJSON = (jsonString) => {
    try {
      JSON.parse(jsonString);
      return { valid: true, error: null };
    } catch (e) {
      return { valid: false, error: e.message };
    }
  };

  const handleJsonChange = (value) => {
    handleChange('jsonInput', value);
    const validation = validateJSON(value);
    if (validation.valid && value.trim()) {
      try {
        const parsed = JSON.parse(value);
        const suggestedName = Object.keys(parsed)[0] || 'Model';
        if (config.modelName === 'Model') {
          handleChange('modelName', suggestedName.charAt(0).toUpperCase() + suggestedName.slice(1));
        }
      } catch (e) {
        // Ignore
      }
    }
  };

  const beautifyJSON = () => {
    try {
      const parsed = JSON.parse(config.jsonInput);
      const beautified = JSON.stringify(parsed, null, 2);
      handleChange('jsonInput', beautified);
    } catch (e) {
      alert('Invalid JSON: ' + e.message);
    }
  };

  const validation = validateJSON(config.jsonInput);

  return (
    <div className="space-y-6">
      {/* Model Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Model Name
        </label>
        <input
          type="text"
          value={config.modelName}
          onChange={(e) => handleChange('modelName', e.target.value)}
          className="w-full px-3 py-2 bg-gray-200 dark:bg-gray-700 rounded text-gray-900 dark:text-white text-sm"
          placeholder="Model"
        />
      </div>

      {/* JSON Input */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            JSON Input
          </label>
          <div className="flex gap-2">
            <button
              onClick={beautifyJSON}
              className="px-3 py-1 text-xs bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded text-gray-700 dark:text-gray-300"
            >
              Beautify
            </button>
          </div>
        </div>
        <textarea
          value={config.jsonInput}
          onChange={(e) => handleJsonChange(e.target.value)}
          rows={12}
          className={`w-full px-3 py-2 bg-gray-800 rounded text-white text-sm font-mono resize-none ${
            config.jsonInput && !validation.valid
              ? 'border-2 border-red-500'
              : 'border border-gray-600'
          }`}
          placeholder='{"name": "John", "age": 30, "email": "john@example.com"}'
        />
        {config.jsonInput && !validation.valid && (
          <p className="mt-1 text-xs text-red-700 dark:text-red-400">{validation.error}</p>
        )}
        {config.jsonInput && validation.valid && (
          <p className="mt-1 text-xs text-green-700 dark:text-green-400">✓ Valid JSON</p>
        )}
      </div>

      {/* Options */}
      <div className="space-y-3">
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={config.useOptional}
            onChange={(e) => handleChange('useOptional', e.target.checked)}
            className="rounded"
          />
          Use Optional Types (for nullable values)
        </label>

        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={config.useMacros}
            onChange={(e) => handleChange('useMacros', e.target.checked)}
            className="rounded"
          />
          Use Swift 5.9+ Macros (Codable macro)
        </label>
      </div>
    </div>
  );
};

export default JsonToModelControls;

